import { TitleColor } from '..';
import Text from '../Text';

const Education2026 = () => (
  <>
    <TitleColor text="Kurser 2026" smallTitle />
    <Text>
      <b>How Emotions Influence Problem Behaviour in Dogs</b>
      <br />
      Webinar 26. marts med Else Verbeek fra Amazing Animal Minds
      <br />
    </Text>
  </>
);

export default Education2026;
